import { Customer } from "./Customer";
import { LoadBankType } from "./Enums";

export class LoadBankApplyParameters {
    parentModal: string = '';
    
    dispatchId: number = 0;
    locCode: string = '';
    loadBankType: LoadBankType = LoadBankType.Load;
    commodityCode: string = '';
    locationId: number = 0;
    locationName: string = '';
    customerId: number = 0;
    customerName: string = '';
    contractNumber: string = '';
    contractIds: number[] = [];
    loadIds: number[] = [];
    
    filterCommodity: boolean = false;
    filterLocation: boolean = false;
    filterCustomer: boolean = false;
    filterContract: boolean = false;
}